<script setup lang="ts">
import { ref, computed } from 'vue'
import { useI18n } from '@/composables/useI18n'
import { useAuth } from '@/composables/useAuth'
import { useStatus } from '@/composables/useStatus'
import { useFilters } from '@/composables/useFilters'
import StatusDropdown from './StatusDropdown.vue'
import NotificationsDropdown from './NotificationsDropdown.vue'
import FilterInput from './FilterInput.vue'
import AdminUserMenu from './AdminUserMenu.vue'

const { t } = useI18n()
const { isAuthenticated } = useAuth()

defineEmits<{
  (e: 'add-entry'): void
}>()

const subscriptionModalOpen = ref(false)

function openSubscriptionModal() {
  document.dispatchEvent(new CustomEvent('open-subscription-modal'))
}
</script>

<template>
  <header class="header">
    <div class="header-content">
      <div class="header-title">
        <div class="brand">
          <a class="brand-link" href="./" :aria-label="t('system-status')">
            <span class="sr-only">{{ t('system-status') }}</span>
            <div class="brand-logo" aria-hidden="true">
              <svg width="196" height="54" viewBox="0 0 196 54" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" class="logo-svg"><title>MiroNet System Status</title><defs><path d="M0 40.223V14.455h8.987l4.59 18.796 4.589-18.796h8.987v25.768h-5.277V20.291h-.574l-5.087 18.795h-5.277L5.85 20.291h-.573v19.932H0zm32.813 0V14.455h5.278v25.768h-5.278zm16.216-8.64v8.64H43.75V14.455h10.096c6.12 0 9.179 2.83 9.179 8.488 0 3.36-1.275 5.836-3.824 7.428l3.71 9.852h-5.776l-3.02-8.64h-5.087zm4.895-4.471c1.25 0 2.18-.38 2.792-1.137.612-.758.918-1.756.918-2.994 0-1.238-.326-2.223-.976-2.956-.65-.732-1.587-1.099-2.81-1.099h-4.82v8.186h4.896zm18.93 7.048c.766 1.314 2.18 1.97 4.246 1.97 2.065 0 3.474-.663 4.226-1.989.752-1.326 1.128-3.55 1.128-6.67s-.383-5.387-1.147-6.802c-.765-1.414-2.168-2.122-4.207-2.122-2.04 0-3.442.708-4.207 2.122-.765 1.415-1.147 3.683-1.147 6.803s.37 5.349 1.109 6.688zm12.583 3.335c-1.606 2.122-4.385 3.183-8.337 3.183s-6.738-1.067-8.357-3.202C67.124 35.34 66.315 32 66.315 27.453c0-4.548.81-7.927 2.428-10.137C70.363 15.106 73.148 14 77.1 14c3.952 0 6.737 1.105 8.356 3.316 1.619 2.21 2.428 5.59 2.428 10.137 0 4.547-.815 7.894-2.447 10.042zM196 0v31.821C196 43.971 186.03 54 173.789 54H96V22.179C96 10.029 105.97 0 118.211 0H196z" id="miro-large"></path></defs><g id="logo/mironet/primary" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g id="Logo"><mask id="logo-mask-2" fill="#fff"><use xlink:href="#miro-large"></use></mask><use id="Combined-Shape" fill="#006580" fill-rule="nonzero" xlink:href="#miro-large"></use><g id="color/solid/primary" mask="url(#logo-mask-2)" fill="#006580" fill-rule="nonzero"><path id="Base" d="M0 0h196v54H0z"></path></g><path d="M114 39.768V14h8.962l6.307 21.221h.385V14h5.308v25.768h-8.731l-6.539-21.22h-.384v21.22H114zm26.654 0V14h16.923v4.547h-11.615v6.026h9.307v4.471h-9.307v6.177h11.615v4.547h-16.923zm18.961-21.145V14h19.231v4.623h-6.923v21.145h-5.308V18.623h-7z" id="NET" fill="#FFF" fill-rule="nonzero" mask="url(#logo-mask-2)"></path></g></g></svg>
            </div>
          </a>
        </div>
        <div class="status-actions">
          <AdminUserMenu v-if="isAuthenticated" />
          <StatusDropdown />
          <NotificationsDropdown />
          <div class="subscribe">
            <button id="subscribeBtn" class="btn btn-ghost" type="button" :aria-label="t('subscribe')" @click="openSubscriptionModal">
              <span class="icon icon-rss" aria-hidden="true"></span>
              <span class="sr-only">{{ t('subscribe') }}</span>
            </button>
          </div>
        </div>
      </div>
      <div class="controls">
        <FilterInput />
        <button
          v-if="isAuthenticated"
          id="addEntryBtn"
          class="btn btn-primary editor-only"
          type="button"
          @click="$emit('add-entry')"
        >
          + Add
        </button>
      </div>
    </div>
  </header>
</template>
